<ng-container
	*ngLet="{
		coacheeNotes: controller.coacheeNotes$ | async,
		sessionUser: controller.sessionUser$ | async,
		coachee: controller.coachee$ | async
	} as data"
	[formGroup]="$any(controller.filterForm)"
>
	<div class="md:flex md:flex-none md:w-52 grid grid-cols-3 gap-6">
		<div class="md:hidden self-center whitespace-pre-line">
			{{ controller.i18n + '.table.column.date' | translate }}
		</div>
		<div class="col-span-2">
			<div class="flex items-center space-x-1">
				<div class="p-inputgroup">
					<p-calendar
						[showClear]="true"
						class="w-full"
						appendTo="body"
						dateFormat="yy-mm-dd"
						formControlName="date"
						styleClass="w-full"
					></p-calendar>
					<span class="p-inputgroup-addon">
						<i class="fak fa-str-calendar"></i>
					</span>
				</div>
				<p-button
					[icon]="controller.dateSortCssIconClass$ | async"
					(onClick)="onDateSortClick()"
					styleClass="p-button-grey border-none text-sm"
				></p-button>
			</div>
		</div>
	</div>
	<div class="md:flex md:flex-1 grid grid-cols-3 gap-6">
		<div class="md:hidden self-center whitespace-pre-line">
			{{ controller.i18n + '.table.column.note' | translate }}
		</div>
		<div class="col-span-2 w-full">
			<input
				[placeholder]="
					controller.i18n + '.table.filter.note.placeholder' | translate
				"
				class="w-full"
				formControlName="note"
				pInputText
			/>
		</div>
	</div>
	<div class="md:flex-none md:w-10">
		<div class="flex justify-end">
			<p-button
				[pTooltip]="controller.i18n + '.table.action.addNote' | translate"
				(click)="onAddClick(data.coachee)"
				icon="fak fa-str-plus"
				iconPos="right"
			></p-button>
		</div>
	</div>
</ng-container>
